import { CFG } from '../config';
import { dayName, sumMacros } from '../utils';
import type { DayData, StravaActivity } from '../types';

interface Props {
  days: DayData[];
  activities: StravaActivity[];
}

export function Insight({ days, activities }: Props) {
  const { protein, daysWithData } = sumMacros(days);
  const parts: string[] = [];

  if (daysWithData > 0) {
    const daysWithCalories = days.filter((d) => d.total > 0);
    const sorted = [...daysWithCalories].sort((a, b) => b.total - a.total);
    const best = sorted[0];
    const worst = sorted[sorted.length - 1];
    if (best && worst && best.date !== worst.date) {
      parts.push(`Больше всего калорий в ${dayName(best.date)} (${best.total}), меньше всего в ${dayName(worst.date)} (${worst.total}).`);
    }
    if (activities.length > 0) {
      const totalMin = activities.reduce((s, a) => s + a.moving_time, 0) / 60;
      parts.push(`Тренировок ${activities.length}, общее время ${Math.round(totalMin)} мин.`);
    }
    const avgP = protein / daysWithData;
    if (avgP < CFG.protein * 0.85) {
      parts.push(`Белок ${Math.round(avgP)}г из ${CFG.protein}г цели. На дефиците это критично для мышц.`);
    }
  } else {
    parts.push('Нет данных за эту неделю. Записывай приёмы пищи через бота.');
  }

  return (
    <div class="insight-wrap">
      <div class="insight-text">{parts.join(' ')}</div>
      <div class="weight-note">Текущий вес: {CFG.weight} кг</div>
    </div>
  );
}
